import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { JsonRpcProvider } from "ethers";
import { CaipNetworkId } from "@reown/appkit";

export interface Token {
  address: string;
  image?: string;
}

export type Tokens = Record<CaipNetworkId, Token>;

// Constants
const CHAIN_ID = 8453;
const DEFAULT_IMAGE_URL = "https://ucwaves.com/logo.webp";

// Environment variables
export const projectId = import.meta.env.VITE_WC_PROJECT_ID;
const rpcUrl = import.meta.env.VITE_RPC_URL;

// WalletConnect metadata
export const metadata = {
  name: "UC WAVES DAPP",
  description: "Next-gen dApp powered by Reown AppKit & WalletConnect v2",
  url: "https://ucwaves.com",
  icons: [DEFAULT_IMAGE_URL],
};

// Ethers adapter setup
const provider = new JsonRpcProvider(rpcUrl);
const customAdapter = new EthersAdapter() as EthersAdapter & {
  _provider?: JsonRpcProvider;
};
customAdapter._provider = provider; // attach JSON-RPC provider

// Base network configuration
const baseNetwork = {
  id: CHAIN_ID,
  name: "Base",
  nativeCurrency: {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: { http: [rpcUrl] },
  },
};

// Initialize AppKit
export const appKit = createAppKit({
  adapters: [customAdapter],
  networks: [baseNetwork],
  metadata,
  projectId,

  features: {
    analytics: true,
    receive: false,
    send: false,
    swaps: false,
    onramp: false,
    history: true,
    allWallets: true,
    email: false,
    socials: false,
  },
  themeMode: "light",
  themeVariables: {
    "--w3m-accent": "#3b82f6",
    "--w3m-font-family": "Arial, sans-serif",
    "--w3m-font-size-master": "10px",
    "--w3m-border-radius-master": "0.5px",
  },
});
